export * from "./SourceCodeDialog";
import SourceCodeDialog from "./SourceCodeDialog";
export default SourceCodeDialog;
